// © 2026 AttainIP Engineering
// Radio: a native radio input drawn round, the Checkbox's sibling for a
// choice of one. The look lives in Radio.css as the `.radio` class, so this
// wrapper and plain-HTML consumers render the same thing. From the
// harvesting design's filter panel (`.fp-option input`, 16px) with the
// design's radio rule for the chosen mark: ink, never brand or blue (the
// design's drawn radio, `#matter-modal input[type="radio"]:checked`, and
// the target state on Components/Radio). Storybook: Components/Harvesting
// Radio.

import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import './Radio.css';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Visible label. Without one, give the radio an `aria-label`. */
  label?: ReactNode;
  /** Read at the row's end, right-aligned in tabular figures: how many the choice holds. */
  count?: ReactNode;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(({ label, count, className, ...props }, ref) => {
  const input = <input ref={ref} type="radio" className={['radio', className].filter(Boolean).join(' ')} {...props} />;
  if (!label && count === undefined) return input;
  return (
    <label className="radio-field">
      {input}
      <span className="radio-field__label">{label}</span>
      {count !== undefined && <span className="radio-field__count">{count}</span>}
    </label>
  );
});

Radio.displayName = 'Radio';
